/* RESPONSIBLE TEAM: team-automation-foundations */
import Step, { IsCustomerFacing } from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';

export default class FreeInput extends Step {
  get supportedChannels() {
    return SUPPORTED_CHANNELS.freeInput;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation, TargetContext.CustomerTicket];
  }

  static get requiredBillingFeature() {
    return 'bot_workflows';
  }

  static createNewStep(store: Store): FreeInput {
    return store.createRecord('operator/visual-builder/step/free-input', {
      type: 'operator/visual-builder/step/free-input',
    });
  }

  static get canBeCustomerFacing() {
    return IsCustomerFacing.Yes;
  }
}
